/**
 * 本から TODO を作る操作。
 *
 * - quickAddBookTodo: 本カードのボタン用。フォーマットが 1 つ（無ければ「{title}を読む」）ならすぐ追加し、2 つ以上なら選ばせる
 * - addBookTodoWithFormat: 1 つのフォーマットで追加する。同じ本・同じタイトルの未完了 TODO があれば追加しない
 */

import { toast } from 'sonner'

import { useBookTodoTemplateStore } from '@/store/useBookTodoTemplateStore'

import {
  type BookTodoFields,
  type BookTodoFormat,
  effectiveBookTodoFormats,
  renderBookTodoTitle,
} from './book-todo-format'

/** 追加したら true。追加済み・失敗なら false */
export const addBookTodoWithFormat = async (format: BookTodoFormat, fields: BookTodoFields): Promise<boolean> => {
  const title = renderBookTodoTitle(format.format, fields)
  if (!title) return false
  const isbn = fields.isbn ?? null
  const store = useBookTodoTemplateStore.getState()
  try {
    if (isbn) {
      await store.loadExistingTitles(isbn)
      if (useBookTodoTemplateStore.getState().existingTitles.get(isbn)?.includes(title)) {
        toast.info(`「${title}」は追加済みです`)
        return false
      }
    }
    await store.addBookTodo({ title, isbn, project: format.project })
    toast.success(`「${title}」を TODO に追加しました`)
    return true
  } catch {
    toast.error('TODO の追加に失敗しました')
    return false
  }
}

export const quickAddBookTodo = async (fields: BookTodoFields, onChoose: () => void): Promise<void> => {
  try {
    await useBookTodoTemplateStore.getState().loadTemplates()
  } catch {
    toast.error('フォーマットの読み込みに失敗しました')
    return
  }
  const formats = effectiveBookTodoFormats(useBookTodoTemplateStore.getState().templates)
  if (formats.length > 1) {
    onChoose()
    return
  }
  const [only] = formats
  if (!only) return
  await addBookTodoWithFormat(only, fields)
}
